module.exports = __webpack_public_path__ + "static/imgVacancie1-c933c618133bc56703c7100418f08267.png";